export const COMPONENT_CLASS = 'popular-widget';
export const POPULAR_EVENTS = 'c-popular-events';
export const POPULAR_EVENTS_DATE = `${POPULAR_EVENTS}__date`;
export const POPULAR_EVENTS_NAME = `${POPULAR_EVENTS}__name-container`;
export const POPULAR_EVENTS_INNER_NAME = `${POPULAR_EVENTS_NAME}--inner-name`;
export const POPULAR_EVENTS_ITEM = `${POPULAR_EVENTS}__item`;
export const POPULAR_EVENTS_LINK = `${POPULAR_EVENTS}__link`;
export const POPULAR_EVENTS_BOOSTED_ODDS = `${POPULAR_EVENTS}__boostedOddsIcon`;
export const POPULAR_TITLE = 'popular_events.title';
export const POPULAR_TITLE_ICON_CLASS_NAME = 'popular-events';

//Google Tag Manager
export const POPULAR_EVENT_GTM_TAG = 'popular-events-widget';
